var React = require('react');

function CircledArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"circled-arrow__circle","cx":"22","cy":"22","fill":"#2a72ff","r":"21.5","key":0}),React.createElement("path",{"className":"circled-arrow__arrow","d":"m17.69 13.3 8.62 8.79-8.62 8.61","fill":"none","stroke":"#fff","strokeWidth":"4","key":1})]);
}

CircledArrow.defaultProps = {"className":"circled-arrow","height":"44","viewBox":"0 0 44 44","width":"44"};

module.exports = CircledArrow;

CircledArrow.default = CircledArrow;
